import type { ASTNode, DocumentNode, FieldNode } from 'graphql';
import { visit, BREAK } from 'graphql';

type ValidParentNode = FieldNode;

const VALID_PARENT_KINDS = new Set(['Field']);

export const getParentNode = (
  document: DocumentNode,
  targetFieldNode: FieldNode,
): ValidParentNode | null => {
  let result: ValidParentNode | null = null;

  visit(document, {
    enter(node, _key, _parent, _path, ancestors) {
      if (node !== targetFieldNode) return;

      for (let i = ancestors.length - 1; i >= 0; i--) {
        const ancestor = ancestors[i] as ASTNode;

        if (VALID_PARENT_KINDS.has(ancestor.kind)) {
          result = ancestor as ValidParentNode;
          break;
        }
      }

      return BREAK;
    },
  });

  return result;
};
